import { createSelector } from 'reselect'
import moment from 'moment'
import dateFormats from '../../configuration/dateFormats'
import { selectIsWalkOn } from '../vehicleSelections/selectors'

export const selectFerryRouteSelectionsState = state =>
  state.ferryRouteSelections

export const selectDepartureDate = createSelector(
  selectFerryRouteSelectionsState,
  ferryRouteSelectionsState => {
    return ferryRouteSelectionsState.departureDate
      ? moment(ferryRouteSelectionsState.departureDate, dateFormats.default)
      : null
  }
)
export const selectDepartureRoute = createSelector(
  selectFerryRouteSelectionsState,
  ferryRouteSelectionsState => ferryRouteSelectionsState.departureRoute
)

export const selectIsCommercial = createSelector(
  selectFerryRouteSelectionsState,
  state => state.isCommercial
)

export const selectReturnDate = createSelector(
  selectFerryRouteSelectionsState,
  ferryRouteSelectionsState => {
    return ferryRouteSelectionsState.returnDate
      ? moment(ferryRouteSelectionsState.returnDate, dateFormats.default)
      : null
  }
)
export const selectReturnRoute = createSelector(
  selectFerryRouteSelectionsState,
  ferryRouteSelectionsState => ferryRouteSelectionsState.returnRoute
)

export const selectActiveRouteForm = createSelector(
  selectFerryRouteSelectionsState,
  ferryRouteSelectionsState => ferryRouteSelectionsState.activeRouteForm
)

export const selectIsReturnTrip = createSelector(
  selectFerryRouteSelectionsState,
  ferryRouteSelectionsState =>
    ferryRouteSelectionsState.activeRouteForm === 'RT'
)

export const selectForcesBooking = createSelector(
  selectFerryRouteSelectionsState,
  ferryRouteSelectionsState => ferryRouteSelectionsState.forcesBooking
)

/**
 * used in selectPassengersForBooking.js only
 */
export const selectPassengerTypeMap = createSelector(
  selectDepartureRoute,
  selectReturnRoute,
  selectIsReturnTrip,
  selectIsWalkOn,
  (departureRoute, returnRoute, isReturn, isWalkOn) => {
    let result = false

    if (departureRoute) {
      result = {}
      result.departure = {}

      const passengerArray =
        isWalkOn && departureRoute.walkOnPassengerTypes
          ? departureRoute.walkOnPassengerTypes
          : departureRoute.passengerTypes

      passengerArray.forEach(({ code, type }) => {
        result.departure[code] = type
      })
    }

    if (isReturn && returnRoute) {
      result.return = {}
      const passengerArray =
        isWalkOn && returnRoute.walkOnPassengerTypes
          ? returnRoute.walkOnPassengerTypes
          : returnRoute.passengerTypes

      passengerArray.forEach(({ code, type }) => {
        result.return[code] = type
      })
    }

    if (!result.return) {
      result.return = { ...result.departure }
    }

    return result
  }
)

// only required in CAT route of NFL-Bay ferry
export const selectPassengerPassportIsRequired = createSelector(
  selectDepartureRoute,
  departureRoute => {
    return departureRoute.code === 'YABA' || departureRoute.code === 'BAYA'
  }
)
